import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const TruckIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <path d="M2 6h11v10H2z" />
    <path d="M13 9h4l4 4v3h-8z" />
    <circle cx="6.5" cy="17.5" r="1.8" />
    <circle cx="17" cy="17.5" r="1.8" />
  </svg>
);

export default TruckIcon;
